// extracted by mini-css-extract-plugin
export default {"container":"oFwKZ","statsContainer":"dZqgI","text":"nhiDP","first":"lTQVK","bigText":"Kj1-S","strong":"rg0kK"};